import type { ContentComponent, InspirationContent } from '../../../../../types/construct.types';
import { HomeTipsInspiration } from '../../../../home-components/home-tips-inspiration/home-tips-inspiration.component';

export const HomeTipsInspirationHandler: ContentComponent<InspirationContent> = ({ content }) => {
	return <HomeTipsInspiration {...content.fields} />;
};
